export default __webpack_public_path__ + "static/avatar-511ac64eef3f73527b1df547bc898a5f.png";